import React from "react";
import { toast } from "react-toastify";
import Title from "designs/v1/components/Title";
import Button from "designs/v1/components/Button";
import {
  createAddressModifyRequestApi,
  getAddressModifyStageApi,
} from "designs/v1/pages/ModifyKyc/services";

const CreateRequest = ({
  stageScreen,
  setStageScreen,
  setStep,
  requestData,
  isLoading,
  setIsLoading,
}) => {
  const createModifyRequest = async () => {
    setIsLoading(true);
    try {
      const payload = { request_type: stageScreen };
      const resp = await createAddressModifyRequestApi(payload);
      console.log("resp", resp);
      setIsLoading(false);
      if (resp.data.message?.status_code !== 200) {
        return toast.error(
          resp.data.message?.message || "Internal server error!"
        );
      }
      localStorage.setItem(
        "AddressRequestNumber",
        resp.data.data?.request_number
      );
      toast.success(resp.data.message?.message);
      setStep("AddressModificationProof");
    } catch (error) {
      const { data } = error.response || {};
      toast.error(
        data.message?.message || "Internal server error!"
      );
      setIsLoading(false);
    }
  };

  const getModifyStage = async () => {
    setIsLoading(true);
    try {
      let payload = { request_type: stageScreen };
      payload["doc_name"] = localStorage.getItem("AddressRequestNumber");
      const resp = await getAddressModifyStageApi(payload);
      let stageList = resp.data?.data?.RekycRequests_flow_status || [];
      let pageName = 0;
      for (let index = 0; index < stageList.length; index++) {
        const element = stageList[index];
        if (pageName === 0) {
          if (element?.modification_details?.status === 0) {
            pageName = "AddressModificationProof";
          } else if (element?.review?.status === 0) {
            pageName = "AddressModificationReview";
          } else if (
            element?.requested_for__esignature?.status === 0 ||
            element?.requested_for__esignature?.status === 1
          ) {
            pageName = "AddressModificationESignature";
          }
        }
      }
      console.log("stage", pageName);
      setStep(pageName);
      setIsLoading(false);
    } catch (error) {
      const { data } = error.response || {};
      toast.error(
        data?.message?.message || "Internal server error!"
      );
      setIsLoading(false);
    }
  };

  const handleCreateRequest = async (value) => {
    if (value === "Yes") {
      getModifyStage();
    } else {
      createModifyRequest();
    }
  };
  return (
    <div>
      <Title title="Address Modification Request" />
      <div className="col-md-12 mt-3">
        {requestData && (
          <div>
            {/* <div className="row mt-4">
              <h5 className="text-bold m-0">Doctype name</h5>
              <div className="row">
                <div className="col-sm">{requestData?.doctype_name}</div>
              </div>
            </div> */}
            <div className="row mt-4">
              <h5 className="text-bold m-0">User Details</h5>
              <div className="row">
                <div className="col-sm">Mobile Number</div>
                <div className="col-sm">{requestData.mobile?.slice(2)}</div>
              </div>
              <div className="row">
                <div className="col-sm">Email Address</div>
                <div className="col-sm">{requestData.email}</div>
              </div>
            </div>
            <div className="row mt-4">
              <h5 className="text-bold m-0">Rekyc request name</h5>
              <div className="row">
                <div className="col-sm">
                  {requestData.rekyc_modi_request_name}
                </div>
              </div>
            </div>
            {requestData.modification_address && (
              <div className="row mt-4">
                <h5 className="text-bold m-0">Modify Address Details</h5>
                <div className="row">
                  <div className="col-sm">
                    {requestData.modification_address}
                  </div>
                </div>
              </div>
            )}
            <div className="row mt-4">
              <h5 className="text-bold m-0">Status</h5>
              <div className="row">
                <div className="col-sm">{requestData.status}</div>
              </div>
            </div>
          </div>
        )}
        <div className="d-flex mt-4">
          <div className="">
            <Button
              type="button"
              title="Back"
              handleClick={() => setStep("ActiveUserInfo")}
              disabled={isLoading}
            />
          </div>
          <div className="mx-2">
            <Button
              title="Create new request"
              handleClick={() => handleCreateRequest("No")}
              loading={isLoading}
            />
          </div>
          <div className="">
            <Button
              title="Continue"
              handleClick={() => handleCreateRequest("Yes")}
              loading={isLoading}
            />
          </div>
        </div>
      </div>
    </div>
  );
};

export default CreateRequest;
